module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Regular.svg?v=4343b04a0a13dedfad2706d3e4514f3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Regular.svg
// module id = 635
// module chunks = 0